<template>
  <div class="recentNews">
    <VueSeamlessScroll :data="data" :class-option="scrollOptions">
      <List
        :loading="loading"
        :data="data"
        :error="error">
            <template v-slot="{item}">
              <div class="newsItem">
                <router-link class="title" :title="item.title" :to="`/news/detail/${item.id}`">{{item.title}}</router-link>
                <span class="time">{{item.createdTs}}</span>
              </div>
            </template>
      </List>
    </VueSeamlessScroll>
  </div>
</template>

<script>
import VueSeamlessScroll from 'vue-seamless-scroll';
import { List } from 'components/common';

export default {
  components: {
    VueSeamlessScroll,
    List,
  },
  props: [
    'loading',
    'data',
    'error',
  ],
  data() {
    return {
      scrollOptions: {
        step: 0.4,
      },
    };
  },
  watch: {
    loading() {
      if (this.data.length > 10) {
        this.startAnimation();
      }
    },
  },
  destroyed() {
    clearInterval(this.interalTimer);
    clearTimeout(this.timeoutTimer);
  },
  methods: {
    startAnimation() {
      
    }
  },
}
</script>

<style lang="less" scoped>
  @import url('~@/assets/styles/vars.less');

  .recentNews {
    max-height: 400px;
    margin-top: 12px;
    overflow: hidden;
    font-size: 16px;
    background: #fff;
    font-family: 'SimSun','Microsoft YaHei';
  }
  .newsItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: @padding-small/2 0;
    a {
      color: @color-primary;
      font-weight: bold;
    }
  }
  .newsItemActive {
    transition: all 1s ease;
  }
  .title {
    color: @color-text-link;
    max-width: 780px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &:hover {
      text-decoration: underline;
    }
  }
  .time {
    color: fadeout(@color-text-normal, 20);
  }
</style>
